export default {
  hasFlashes: state => 0 < state.flashes.length,
  getFlashes: state => state.flashes,
  flashesRef: state => state.flashesRef,
};
